/* Settings are rendered by thermal-aid-block.liquid. Cart remains a preview. */
(() => {
  if (window.thermalAidSectionBooted) return;
  window.thermalAidSectionBooted = true;
  const instances = new WeakMap();
  function initialize(scope) {
    if (instances.has(scope)) return;
    const controller = new AbortController();
    let disposed = false;
  const track = scope.querySelector('.animals-track');
  const viewport = scope.querySelector('.animals-window');
  const carousel = scope.querySelector('.animals');
  const status = scope.querySelector('.carousel-status');
  const mobile = window.matchMedia('(max-width: 767px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const config = {};
  if (carousel.hasAttribute('data-autoplay')) config.autoplay = carousel.dataset.autoplay === 'true';
  if (carousel.hasAttribute('data-autoplay-interval')) config.interval = Number(carousel.dataset.autoplayInterval);
  scope.querySelectorAll('.animal-card').forEach(card => {
    const url = config.productUrls?.[card.dataset.product]?.trim();
    if (!url) return;
    try {
      const parsed = new URL(url, window.location.href);
      if (!['http:', 'https:'].includes(parsed.protocol) && !url.startsWith('/products/')) return;
      card.setAttribute('href', url);
      card.removeAttribute('aria-disabled');
    } catch { /* Leave the card disabled until a valid URL is supplied. */ }
  });
  const originals = Array.from(track.children);
  const count = originals.length;
  // Duplicate both ends so the loop never exposes an empty space.
  for (const side of ['before', 'after']) {
    const fragment = document.createDocumentFragment();
    originals.forEach(item => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelector('.animal-card').tabIndex = -1;
      fragment.append(clone);
    });
    if (side === 'before') track.prepend(fragment);
    else track.append(fragment);
  }
  let index = count;
  let width = 0;
  let animation = null;
  let gesture = null;
  let suppressClickUntil = 0;
  const offset = () => -index * width;
  const position = x => { track.style.transform = 'translate3d(' + x + 'px,0,0)'; };
  function announce() {
    const first = ((index - count) % count + count) % count;
    status.textContent = Array.from({ length: mobile.matches ? 3 : 4 }, (_, i) => originals[(first + i) % count].textContent.trim()).join(', ');
  }
  function normalize() {
    index = count + ((index - count) % count + count) % count;
    position(offset());
    Array.from(track.children).forEach((item, i) => {
      const visible = i >= index && i < index + (mobile.matches ? 3 : 4);
      item.setAttribute('aria-hidden', String(!visible));
      item.querySelector('.animal-card').tabIndex = visible ? 0 : -1;
    });
  }
  function move(direction, from = offset()) {
    if (animation) return;
    index += direction;
    const to = offset();
    position(to);
    if (reducedMotion.matches || Math.abs(from - to) < 1) {
      normalize();
      announce();
      return;
    }
    animation = track.animate([
      { transform: 'translate3d(' + from + 'px,0,0)' },
      { transform: 'translate3d(' + to + 'px,0,0)' }
    ], { duration: 360, easing: 'cubic-bezier(.22,.61,.36,1)' });
    animation.onfinish = () => { animation = null; normalize(); announce(); };
  }
  function resize() {
    if (animation) { animation.cancel(); animation = null; }
    gesture = null;
    viewport.classList.remove('is-dragging');
    width = viewport.clientWidth / (mobile.matches ? 3 : 4);
    normalize();
  }
  const resizeObserver = new ResizeObserver(resize);
  resizeObserver.observe(viewport);
  resize();
  scope.querySelector('.next').addEventListener('click', () => move(1));
  scope.querySelector('.previous').addEventListener('click', () => move(-1));
  carousel.addEventListener('keydown', event => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    }
  });
  viewport.addEventListener('pointerdown', event => {
    if (!event.isPrimary || event.button !== 0 || animation) return;
    gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, dragging: false };
  });
  viewport.addEventListener('pointermove', event => {
    if (!gesture || gesture.id !== event.pointerId) return;
    const dx = event.clientX - gesture.x;
    const dy = event.clientY - gesture.y;
    if (!gesture.dragging) {
      if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) { gesture = null; return; }
      if (Math.abs(dx) < 8) return;
      gesture.dragging = true;
      viewport.setPointerCapture(event.pointerId);
      viewport.classList.add('is-dragging');
    }
    gesture.dx = Math.max(-width, Math.min(width, dx));
    position(offset() + gesture.dx);
  });
  function finishGesture(event) {
    if (!gesture || gesture.id !== event.pointerId) return;
    const { dx, dragging } = gesture;
    gesture = null;
    viewport.classList.remove('is-dragging');
    if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
    if (!dragging) return;
    suppressClickUntil = Date.now() + 400;
    const direction = event.type !== 'pointercancel' && Math.abs(dx) > width * .22 ? (dx < 0 ? 1 : -1) : 0;
    move(direction, offset() + dx);
  }
  viewport.addEventListener('pointerup', finishGesture);
  viewport.addEventListener('pointercancel', finishGesture);
  viewport.addEventListener('lostpointercapture', finishGesture);
  viewport.addEventListener('pointerleave', event => { if (gesture && !gesture.dragging) gesture = null; });
  viewport.addEventListener('dragstart', event => event.preventDefault());
  viewport.addEventListener('click', event => {
    const card = event.target.closest('.animal-card');
    if (Date.now() < suppressClickUntil || (card && !card.hasAttribute('href'))) event.preventDefault();
  });
  const interval = Math.max(1500, Number(config.interval) || 4000);
  let enabled = config.autoplay === true && !reducedMotion.matches;
  let timer = null;
  let hovering = false;
  let inView = true;
  function syncAutoplay() {
    clearTimeout(timer);
    if (disposed) return;
    const focused = carousel.contains(document.activeElement);
    const running = enabled && !hovering && !focused && !document.hidden && inView && !gesture;
    status.setAttribute('aria-live', running ? 'off' : 'polite');
    if (running) timer = setTimeout(() => {
      if (!animation && !gesture) move(1);
      syncAutoplay();
    }, interval);
  }
  carousel.addEventListener('pointerenter', event => {
    if (event.pointerType === 'mouse') { hovering = true; syncAutoplay(); }
  });
  carousel.addEventListener('pointerleave', event => {
    if (event.pointerType === 'mouse') { hovering = false; syncAutoplay(); }
  });
  carousel.addEventListener('focusin', syncAutoplay);
  carousel.addEventListener('focusout', () => setTimeout(syncAutoplay, 0));
  carousel.addEventListener('pointerdown', () => clearTimeout(timer));
  carousel.addEventListener('pointerup', syncAutoplay);
  carousel.addEventListener('pointercancel', syncAutoplay);
  carousel.addEventListener('click', syncAutoplay);
  document.addEventListener('visibilitychange', syncAutoplay, { signal: controller.signal });
  reducedMotion.addEventListener('change', () => {
    enabled = config.autoplay === true && !reducedMotion.matches;
    syncAutoplay();
  }, { signal: controller.signal });
  const intersectionObserver = new IntersectionObserver(entries => {
    inView = entries[0].isIntersecting;
    syncAutoplay();
  }, { threshold: 0 });
  intersectionObserver.observe(carousel);
  syncAutoplay();



  scope.querySelector('.mobile-cta').addEventListener('click', event => {
    event.preventDefault();
    const carousel = scope.querySelector('.animals');
    carousel.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
    carousel.focus({ preventScroll: true });
  });

    instances.set(scope, () => {
      disposed = true;
      clearTimeout(timer);
      controller.abort();
      resizeObserver.disconnect();
      intersectionObserver.disconnect();
      if (animation) animation.cancel();
      instances.delete(scope);
    });
  }
  function mount(container) {
    container.querySelectorAll('[data-thermal-aid-section]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-thermal-aid-section]').forEach(scope => instances.get(scope)?.());
  });
})();
